import { PplxError } from '#pplx/frontend/common/errors.js';
export class CometError extends PplxError {
    name = 'CometError';
}
//# sourceMappingURL=errors.js.map